export interface BrandHonor {
  year: string;
  title: string;
  description: string;
}

export const brandInfo = {
  name: '蜜芽',
  fullName: '蜜芽母婴跨境电商平台',
  founded: '2014年',
  mission: '为中国家庭提供安全、正品、高性价比的母婴商品，让每位妈妈轻松选购全球好货，守护宝宝健康成长。',
  description: `蜜芽是中国领先的母婴跨境电商平台，成立于2014年，总部位于北京。平台汇聚全球3000+优质母婴品牌，涵盖奶粉、纸尿裤、玩具、童装、喂养用品、洗护用品等海量品类，SKU超过10万个。

蜜芽以"让中国宝宝用上全球好货"为使命，建立了严格的供应商审核机制和正品保障体系。所有商品均与品牌方或授权经销商直接合作，从源头确保商品品质。平台拥有专业的跨境供应链团队，在日韩、澳洲、欧洲、北美等地区建立了直采中心，为消费者提供高效便捷的跨境购物体验。

同时，蜜芽打造了专业的育儿内容生态，汇集儿科医生、营养师、育儿专家构建专业内容矩阵，为妈妈们提供科学、实用、温暖的育儿知识。平台累计服务超过5000万中国家庭，深受妈妈们的信赖与喜爱。`,
  values: [
    { title: '正品保障', icon: 'ri-shield-check-line', desc: '品牌直供，100%正品承诺，假一赔十' },
    { title: '全球精选', icon: 'ri-global-line', desc: '汇聚全球3000+母婴品牌，精选好物直达' },
    { title: '专业服务', icon: 'ri-service-line', desc: '专业育儿顾问团队，为妈妈答疑解惑' },
    { title: '高性价比', icon: 'ri-money-cny-circle-line', desc: '源头直采，减少中间环节，好货不贵' },
  ],
  honors: [
    { year: '2024', title: '中国跨境电商百强企业', description: '连续第四年入选中国跨境电商百强榜单，母婴品类排名前三' },
    { year: '2023', title: '消费者最信赖母婴平台', description: '获得中国消费者协会评选的"消费者最信赖母婴电商平台"称号' },
    { year: '2022', title: '年度最具影响力母婴品牌', description: '荣获中国电子商务协会颁发的年度最具影响力母婴品牌奖' },
    { year: '2021', title: 'ISO 9001质量管理体系认证', description: '通过国际标准化组织ISO 9001质量管理体系认证' },
    { year: '2020', title: '国家级高新技术企业', description: '被认定为国家高新技术企业，拥有多项供应链和智能推荐核心技术' },
    { year: '2019', title: '最佳用户体验奖', description: '获得互联网行业最佳用户体验奖，NPS净推荐值行业领先' },
  ] as BrandHonor[],
  contact: {
    address: '北京市朝阳区望京SOHO T1-B座 2001-2010',
    phone: '400-888-6688',
    email: 'service@mia.com',
    workingHours: '周一至周日 9:00 - 21:00',
  },
  stats: [
    { value: '5000万+', label: '服务用户' },
    { value: '3000+', label: '合作品牌' },
    { value: '10万+', label: '精选SKU' },
    { value: '99.7%', label: '好评率' },
  ],
};